import {
  DatePicker,
  Select,
  Button,
  Space,
  message
} from 'antd'
import { useState, useEffect } from 'react'
import QueryFormComponent from "../components/queryFormComponent";
import TableComponent from "../components/tableComponent";
import AuthComponent from '../../../components/AuthComponent';
import service from "../../../@services";
import DeleteComponent from "./components/deleteComponent";


const Prefecture = (props) => {
  const [list, setList] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)
  const [deleteVisible, setDeleteVisible] = useState(false)
  const [deleteFormVal, setDeleteFormVal] = useState({})
  const [formVal, setFormVal] = useState({
    title: "",
    status: null
  })
  const [delContent, setDelContent] = useState('')
  const [pageSetting, setPageSetting] = useState({
    pageIndex: 1,
    pageSize: 20
  })
  const [btnType, setBtnType] = useState('')

  // 查询表单
  const fields = [
    {
      label: '专区名称',
      name: 'title',
      placeholder: '请输入专区名称或ID'
    },
    {
      label: '专区状态',
      name: 'status',
      component: (
        <Select allowClear style={{ width: 200 }} placeholder="请选择专区状态">
          <Select.Option value={null}>全部</Select.Option>
          <Select.Option value={1}>启用</Select.Option>
          <Select.Option value={0}>禁用</Select.Option>
        </Select >
      )
    },
  ]
  // 表格头
  const columns = [
    {
      title: 'ID',
      key: 'id',
      dataIndex: 'id',
      align: 'center'
    },
    {
      title: '专区名称',
      key: 'title',
      dataIndex: 'title',
      align: 'center',
    },
    {
      title: '状态',
      align: 'center',
      render: (row) => {
        if (row.status === 1) {
          return '启用'
        } else {
          return '禁用'
        }
      }
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      align: 'center'
    },
    {
      title: '创建人',
      dataIndex: 'createName',
      key: 'createName',
      align: 'center'
    },
    {
      title: '操作',
      align: 'center',
      render: (row) => (
        <Space>
          <AuthComponent authKey="/mallZone/detail/{id}">
            <Button
              type="link"
              onClick={() => handleRecommend('see', row)}
            >查看</Button>
          </AuthComponent>
          <AuthComponent authKey="/mallZone/detail/{id}">
            <Button
              type="link"
              onClick={() => handleRecommend('edit', row)}
            >编辑</Button>
          </AuthComponent>
          <AuthComponent authKey="/mallZone/updateStatus">
            <Button
              type="link"
              onClick={() => handleRecommend('disable', row)}
            >{row.status === 0 ? '启用' : '禁用'}</Button>
          </AuthComponent>
          <AuthComponent authKey="/mallZone/delete/{id}">
            <Button
              type="link"
              onClick={() => handleRecommend('delete', row)}
            >删除</Button>
          </AuthComponent>

        </Space >
      )
    }
  ]
  // 列表查询
  const getList = () => {
    setLoading(true)
    const params = Object.assign({}, formVal, pageSetting)
    service.prefecture.mallZoneList(params).then(res => {
      setTotal(res.recordCount)
      setList(res.result)
    }).catch(err => console.log(err)).finally(() => {
      setLoading(false)
    })
  }
  // 查询
  const searchFormFn = (val) => {
    if (val.operTime && val.operTime.length > 0) {
      let formatVal = format(val)
      setFormVal({ ...formatVal })
    } else {
      setFormVal({ ...val })
    }
    setPageSetting({
      pageIndex: 1,
      pageSize: 20
    })
  }
  // 操作合集
  const handleRecommend = (type, val) => {
    setBtnType(type)
    if (type === 'delete' || type === 'disable') {
      // 删除
      setDeleteFormVal(val)
      setDeleteVisible(true)
      setDelContent(type === 'delete' ? `确认删除 ${val.title} 吗? ` : `确认${val.status ? '禁用' : '启用'} ${val.title} 吗? `)
    } else if (type === 'edit') {
      props.history.push(`/mallZone/edit?id=${val.id}`)
    } else if (type === 'see') {
      props.history.push(`/mallZone/detail?id=${val.id}`)
    } else {
      props.history.push("/mallZone/create?type=mallZone")
    }
  }
  // 删除/启用禁用
  const deleteFn = ({ id, status }) => {
    if (btnType === 'delete') {
      service.prefecture.mallZoneDelete(id).then(res => {
        message.success('删除成功')
        setDeleteVisible(false)
        getList()
      }).catch(err => console.log(err))
    } else {
      service.prefecture.mallZoneUpdateStatus({
        status: status ? 0 : 1,
        id
      }).then(res => {
        message.success('操作成功')
        setDeleteVisible(false)
        getList()
      }).catch(err => console.log(err))
    }
  }
  useEffect(() => {
    getList()
  }, [pageSetting])

  return (
    <div className="home-mall">
      <QueryFormComponent
        name="Prefecture"
        fields={fields}
        authKey={{ search: '/mallZone/list' }}
        onSearch={searchFormFn}
      />
      <TableComponent
        loading={loading}
        columns={columns}
        btnName="新增"
        page={pageSetting}
        total={total}
        list={list}
        authKey={{ search: '/mallZone/create' }}
        addRecommend={() => handleRecommend()}
        changePage={(val) => setPageSetting(val)}
      />
      <DeleteComponent
        visible={deleteVisible}
        title="提示"
        content={delContent}
        onCancel={() => setDeleteVisible(false)}
        onOk={(id) => deleteFn(id)}
        formVal={deleteFormVal}
      />
    </div>
  )
}

export default Prefecture